<template>
  <div
    class="wrapper"
    :class="wrapperClass(props.column)"
  >
    <template v-if="props.column.type === 'checkbox-selection'">
      <hcl-form-input-checkbox
        class="column-checkbox-selection"
        :id="columnId"
        :name="props.column.name"
        label=""
        :value="columnValue.value"
        :checked="columnCheckboxIsChecked"
        v-on:hcl-form-input-checkbox-changed="columnCheckboxOnValueChanged(props.column.type, $event)"
      >
      </hcl-form-input-checkbox>
    </template>
    <template v-else-if="props.column.type === 'checkbox'">
      <hcl-form-input-checkbox
        class="column-checkbox"
        :id="columnId"
        :name="props.column.name"
        label=""
        :value="columnValue.value"
        :checked="columnCheckboxIsChecked"
        v-on:hcl-form-input-checkbox-changed="columnCheckboxOnValueChanged(props.column.type, $event)"
      >
      </hcl-form-input-checkbox>
    </template>
    <template v-else-if="props.column.type === 'actions'">
      <template v-if="columnActionsHasActions">
        <template v-if="columnActionsCollapsed">
          <hcl-dropdown
            type="kebab"
            align="right"
            class="column-actions column-actions-collapsed float-right"
            :id="columnId"
          >
            <hcl-button
              v-for="(item, index) in columnActions"
              class="actions-button dropdown-item header-menu-link-margin"
              :key="index"
              :type="item.attributes.type && item.attributes.type !== ''
                  ? item.attributes.type
                  : item.attributes.widget && item.attributes.widget !== ''
                    ? 'widget'
                    : 'link'
                "
              variant="btn-link"
              :id="index.toString()"
              v-bind="columnActionsItemAttributesKebab(item)"
              :widget-element="item.element"
              :widget-attributes="columnActionsItemWidgetAttributes(item)"
            >{{ item }}
            </hcl-button>
          </hcl-dropdown>
        </template>
        <template v-else>
          <hcl-button-group class="column-actions mx-2">
            <hcl-button
              v-for="(item, index) in columnActions"
              class="actions-button"
              :key="index"
              :type="item.attributes.type && item.attributes.type !== ''
                  ? item.attributes.type
                  : item.attributes.widget && item.attributes.widget !== ''
                    ? 'widget'
                    : 'link'
                "
              variant="btn-link"
              :id="index.toString()"
              v-bind="columnActionsItemAttributesButtonGroup(item)"
              :widget-element="item.element"
              :widget-attributes="columnActionsItemWidgetAttributes(item)"
            >{{ item }}
            </hcl-button>
          </hcl-button-group>
        </template>
      </template>
    </template>
    <template v-else-if="props.column.type === 'toggle'">
      <a
        class="column-toggle"
        :title="columnToggleTitle()"
        @click="columnToggleOnClicked"
      >
        <i :class="columnToggleCssClasses()"></i>
      </a>
    </template>
    <template v-else-if="props.column.type === 'html'">
      <span
        class="column-html"
        v-html="columnValue"
      ></span>
    </template>
    <template v-else-if="props.column.type === 'text'">{{ columnValue }}</template>
    <template v-else-if="props.column.type === 'number'">{{ columnValue }}</template>
    <template v-else-if="props.column.type === 'image'">
      <div
        class="column-image image-wrapper"
        :height="columnImageDimensions.height"
        :width="columnImageDimensions.width"
      >
        <img
          class="column-image image"
          :class="columnImageClass"
          :height="columnImageDimensions.height"
          :width="columnImageDimensions.width"
          :title="columnId"
          :src="columnValue.src"
        />
      </div>
    </template>
    <template v-else-if="props.column.type === 'image-full-height'">
      <div
        class="column-image-full-height image-wrapper"
        :height="columnImageDimensions.height"
        :width="columnImageDimensions.width"
      >
        <img
          class="column-image-full-height image"
          :class="columnImageClass"
          :title="columnId"
          :src="columnValue.src"
        />
      </div>
    </template>
    <template v-else-if="props.column.type === 'status'">
      <i
        class="column-status eii--fa6-solid--circle"
        :style="{ color: columnValue.color }"
      ></i>
    </template>
    <template v-else-if="props.column.type === 'badge'">
      <template v-if="columnValue.url">
        <a :href="columnValue.url">
          <span
            class="column-badge badge"
            :class="columnValue.color"
          >
            <i :class="columnValue.icon"></i>
            {{ columnValue.text }}
          </span>
        </a>
      </template>
      <template v-else>
        <span
          class="column-badge badge"
          :class="columnValue.color"
        >
          <i :class="columnValue.icon"></i>
          {{ columnValue.text }}
        </span>
      </template>
    </template>
    <template v-else-if="props.column.type === 'donut'">
      <div
        class="donut-canvas-wrapper"
        :style="{ height: columnDonutSize(columnValue) + 'px', width: columnDonutSize(columnValue) + 'px' }"
      >
        <Doughnut
          ref="donutChartRef"
          class="donut-canvas float-left"
          :data="columnDonutData(columnValue)"
          :options="columnDonutOptions()"
        />
      </div>
    </template>
    <template v-else-if="props.column.type === 'tags'">
      <span class="column-tags tags">
        <template v-for="item in columnValue">
          <a
            v-if="item.link !== ''"
            :href="item.link"
          >
            <span
              :key="columnId + '-' + item.text"
              class="tags-tag badge"
              :data-title="item.title"
              :data-close="item.close"
              :data-link="item.link"
              :widget="item.widget"
              :style="columnTagsBackgroundColor(item.color)"
              v-bind="item.data"
            >
              {{ item.text }}
            </span>
          </a>
          <span
            v-else
            :key="columnId + '-' + item.text"
            class="tags-tag badge"
            :data-title="item.title"
            :data-close="item.close"
            :data-link="item.link"
            :widget="item.widget"
            :style="columnTagsBackgroundColor(item.color)"
            v-bind="item.data"
          >
            {{ item.text }}
          </span>
        </template>
      </span>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref, Ref, computed, watch, inject, unref } from 'vue'

import { useIO } from '@/composables/io'

import { DefinitionListContentColumn, DataListRowEntityEntry, DefinitionListContentConfiguration, DataListLookup, DefinitionListContentConfigurationSelection } from '@/components/types'

import { useStateStore } from '@/stores/state'

import HclFormInputCheckbox from '@/components/FormInputCheckbox/FormInputCheckbox.vue'
import HclDropdown from '@/components/Dropdown/Dropdown.vue'
import HclButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue'
import HclButton from '@/components/Button/Button.vue'

import { Doughnut } from 'vue-chartjs'

import { Chart, DoughnutController, ArcElement, Tooltip, LinearScale } from 'chart.js'

Chart.register(DoughnutController, ArcElement, Tooltip, LinearScale)

interface Props {
  column: DefinitionListContentColumn
  config: DefinitionListContentConfiguration
  lookups: DataListLookup[]
  entry: DataListRowEntityEntry
  selection: DefinitionListContentConfigurationSelection
  id: string | number
  index: string | number
  columncount: number,
  actionscount: number
  rowHeight?: number
}

const props = withDefaults(defineProps<Props>(), {
  column: undefined,
  config: undefined,
  lookups: () => [],
  entry: undefined,
  selection: undefined,
  id: undefined,
  index: undefined,
  columncount: undefined,
  actionscount: undefined,
  rowHeight: 100
})

const blockMetaId: string = inject('blockMetaId', '')
const parentActionListId: Ref<string> = inject('parentActionListId', ref(''))

const { performPostBucket, performGetBucket } = useIO()

const { updateBlockGroupNameValue } = useStateStore()

const hclWrapperElement = inject<HTMLElement | undefined>('hclWrapperElement')

/*
 * Global Handling
 */
const columnIdentityName = computed(() => {
  return props.config.identity.name || 'id'
})

const columnId = computed(() => {
  return props.column.name + '-' + props.entry.values[columnIdentityName.value]
})

const columnValue = computed(() => {
  const lookupForColumn = props.lookups?.filter((lookup) => {
    return lookup.name === props.column.name
  })

  if (lookupForColumn.length === 0) return props.entry.values[props.column.name]

  const valueForColumn = lookupForColumn[0].values.filter((value) => {
    return value.value === props.entry.values[props.column.name]
  })

  if (valueForColumn.length === 0) return props.entry.values[props.column.name]

  return valueForColumn[0].text
})

const wrapperClass = (column: DefinitionListContentColumn) => {
  const classes: string[] = []

  if (column.css && column.css.length > 0) {
    for (const cssClass of column.css) {
      classes.push(cssClass)
    }
  }

  return classes.join(' ')
}

/*
 * Checkbox Handling
 */
const emit = defineEmits(['hcl-list-row-checkbox-changed'])

const merge = (source: object, target: object) => {
  for (const [key, val] of Object.entries(source)) {
    if (val !== null && typeof val === `object`) {
      if (target[key] === undefined) {
        target[key] = new val.__proto__.constructor()
      }
      merge(val, target[key])
    } else {
      target[key] = val
    }
  }
  return target
}

const columnIsCheckbox = (column) => {
  return ['checkbox', 'checkbox-selection'].includes(column.type)
}

const columnCheckboxIsChecked = computed(() => {
  if (!columnIsCheckbox(props.column)) return 'false'

  if (columnValue.value?.on?.value === columnValue.value?.value) {
    return 'true'
  }

  return 'false'
})

const hasLocalActionListId = computed(() => {
  return parseInt(props.entry.state?.actionlist?.id ?? '0', 10) > 0
})

const hasGlobalActionListId = computed(() => {
  return parseInt(parentActionListId.value, 10) > 0
})

const columnCheckboxUpdateValue = (targetValue: string, payload: object) => {
  let matchCheckbox: any | undefined = undefined

  if (columnValue.value.on.value === targetValue) {
    matchCheckbox = columnValue.value.on
  }

  if (columnValue.value.off.value === targetValue) {
    matchCheckbox = columnValue.value.off
  }

  if (matchCheckbox === undefined) return

  if (matchCheckbox.action === 'post') {
    let mergedData = {}
    merge(matchCheckbox.data, mergedData)

    if (payload) {
      merge(payload, mergedData)
    }

    performPostBucket(
      matchCheckbox.target,
      {},
      {
        ...mergedData
      },
      '',
      () => { }
    )
  }

  if (matchCheckbox.action === 'get') {
    performGetBucket(
      matchCheckbox.target,
      {},
      '',
      () => { }
    )
  }

  return
}

const columnCheckboxOnValueChanged = (type: string, event) => {
  const targetValue = event.checked ? columnValue.value.on.value : columnValue.value.off.value
  columnValue.value.value = targetValue

  let payload = {} as any

  if (hasGlobalActionListId.value) {
    // do not change the name of the key 'listId', it is passed one-to-one to the backend
    payload = {
      listId: parentActionListId
    }
  }
  if (hasLocalActionListId.value) {
    // do not change the name of the key 'listId', it is passed one-to-one to the backend
    payload = {
      listId: props.entry.state.actionlist?.id ?? '0'
    }
  }

  columnCheckboxUpdateValue(
    targetValue ?? '',
    payload
  )

  emit('hcl-list-row-checkbox-changed', event)
}

watch(
  () => props.selection.header.selected,
  (n, o) => {
    if (props.column.type !== 'checkbox-selection') return

    if (n === o) return

    const targetValue = n ? columnValue.value.on.value : columnValue.value.off.value

    if (props.entry.values[props.column.name].value !== targetValue) {
      columnValue.value.value = targetValue
      let payload = {} as any

      if (hasGlobalActionListId.value) {
        // do not change the name of the key 'listId', it is passed one-to-one to the backend
        payload = {
          listId: parentActionListId
        }
      }
      if (hasLocalActionListId.value) {
        // do not change the name of the key 'listId', it is passed one-to-one to the backend
        payload = {
          listId: props.entry.state.actionlist?.id ?? '0'
        }
      }

      columnCheckboxUpdateValue(
        targetValue ?? '',
        payload
      )
    }
  }
)

/*
 * Actions Handling
 */
const columnActionsHasActions = computed(() => {
  return 'actionArray' in props.entry.values
})

const columnActions = computed(() => {
  return columnActionsHasActions.value ? props.entry.values['actionArray'] : []
})

const columnActionsIconsMax = computed(() => {
  return props.config.rows.columns.actions.icons || 3
})

const columnActionsCollapsed = computed(() => {
  return props.actionscount > columnActionsIconsMax.value
})

const columnActionsItemAttributesKebab = (entry) => {
  if ('attributes' in entry) return entry.attributes

  return {}
}

const columnActionsItemAttributesButtonGroup = (entry) => {
  if ('attributes' in entry) {
    const { title, ...response } = entry.attributes
    return { title: '', ...response }
  }

  return {}
}

const columnActionsItemWidgetAttributes = (entry) => {
  if ('widget' in entry) return entry.widget

  return {}
}

/*
 * Toggle Handling
 */
const columnToggleCssClasses = () => {
  const value = columnValue.value.value

  return columnValue.value[value].css
}

const columnToggleTitle = () => {
  const value = columnValue.value.value

  return columnValue.value[value].title
}

const columnToggleOnClicked = () => {
  const value = columnValue.value.value
  const toggleState = columnValue.value[value]

  if (toggleState.type === 'post') {
    performPostBucket(
      columnValue.value[value].url,
      {},
      {
        data: {}
      },
      '',
      () => {
        updateBlockGroupNameValue(blockMetaId, 'global', 'search', true)
      }
    )
  }
  if (toggleState.type === 'link') {
    window.location.href = columnValue.value[value].url
  }
}

/*
 * Image Handling
 */
const columnImageDimensions = computed(() => {
  if (props.column.type === 'image') {
    return {
      height: columnValue.value.height + 'px',
      width: columnValue.value.width + 'px'
    }
  }

  if (props.column.type === 'image-full-height') {
    /* no downscaling, only upscaling */
    if (props.rowHeight <= parseInt(columnValue.value.height, 10)) {
      return {
        height: columnValue.value.height + 'px',
        width: columnValue.value.width + 'px'
      }
    }

    const newWidth =
      parseInt(columnValue.value.width, 10) *
      (props.rowHeight / parseInt(columnValue.value.height, 10))

    return {
      height: props.rowHeight + 'px',
      width: newWidth + 'px'
    }
  }

  return { height: '0px', width: '0px' }
})

const columnImageClass = computed(() => {
  const modes = ['contain', 'cover', 'scale-down']

  if (props.column.type === 'image' || props.column.type === 'image-full-height') {
    if ('mode' in columnValue.value && columnValue.value['mode'] !== '' && modes.includes(columnValue.value['mode'])) {
      return 'image-mode-' + columnValue.value['mode']
    }

    return 'image-mode-scale-down'
  }

  return ''
})

/*
 * Donut Handling
 */
const donutChartRef = ref()

const columnDonutData = (values: any) => {
  const labels: string[] = []
  const data: number[] = []
  const backgroundColor: string[] = []

  for (const section of values?.sections) {
    labels.push(section.label)
    data.push(section.value)
    backgroundColor.push(section.color)
  }

  return {
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: backgroundColor
      }
    ]
  }
}

const columnDonutSectionClicked = ref(undefined)

watch(
  columnDonutSectionClicked,
  (n) => {
    if (n) {
      columnValue.value?.sections?.filter((section) => {
        if (section.label === columnDonutSectionClicked.value) {
          if (!('url' in section)) return

          window.location.href = section.url
        }
      })
    }
  }
)

const getOrCreateTooltipElement = (chart) => {
  let tooltipElement: HTMLElement = chart.canvas.parentNode.querySelector('div')

  if (!tooltipElement) {
    tooltipElement = document.createElement('div')
    tooltipElement.classList.add('donut-tooltip')

    chart.canvas.parentNode.appendChild(tooltipElement)
  }

  return tooltipElement;
}

const createTableBodyRow = (chartData, index, sum, current) => {
  const trElement = document.createElement('tr')

  parseInt(index) === current ? trElement.classList.add('current') : null

  // td for segment color
  const colorBackground = chartData.datasets[0].backgroundColor[index]

  const spanColorBackground = document.createElement('span')
  spanColorBackground.style.background = colorBackground

  const tdColor = document.createElement('td')
  tdColor.appendChild(spanColorBackground)
  trElement.appendChild(tdColor)

  // td for segment label
  const nodeLabel = document.createTextNode(chartData.labels[index])

  const tdLabel = document.createElement('td')
  tdLabel.append(nodeLabel)
  trElement.appendChild(tdLabel)

  // td for segment value and percentage
  const value = chartData.datasets[0].data[index]
  const valueText = value + ' (' + parseFloat(((value / sum) * 100).toFixed(1)) + '%)'
  const nodeValue = document.createTextNode(valueText)

  const tdValue = document.createElement('td')
  tdValue.append(nodeValue)
  trElement.appendChild(tdValue)

  return trElement
}

const columnDonutTooltipHandler = (context) => {
  const { chart, tooltip } = context

  if (chart.config.data.datasets.length !== 1 || !(chart.config.data.labels.length > 0 && tooltip.dataPoints.length > 0)) return

  const segmentIndex = tooltip.dataPoints[0].dataIndex
  const segmentColumnValue = columnValue.value.sections[segmentIndex]
  const segmentHasUrl = segmentColumnValue && 'url' in segmentColumnValue && segmentColumnValue['url'] !== ''

  const cursor = document.body.style.cursor
  document.body.style.cursor = segmentHasUrl && cursor !== 'pointer' ? 'pointer' : ''

  const tooltipElement = getOrCreateTooltipElement(chart)

  if (tooltip.opacity === 0) {
    tooltipElement.style.opacity = '0'
    return;
  }

  const chartData = chart.config.data

  if (tooltip.body) {
    const tableBody = document.createElement('tbody');

    let sum = 0
    for (const index in chartData.labels) {
      sum += chartData.datasets[0].data[index]
    }

    for (const index in chartData.labels) {
      const tableBodyRow = createTableBodyRow(chartData, index, sum, segmentIndex)
      tableBody.appendChild(tableBodyRow);
    }

    const tooltipTableElement = tooltipElement.querySelector('table');

    if (!tooltipTableElement) {
      const tableElement = document.createElement('table');
      tableElement.appendChild(tableBody)
      tooltipElement.appendChild(tableElement);
    } else {
      tooltipTableElement.firstChild?.remove()
      tooltipTableElement.appendChild(tableBody)
    }
  }

  if (!hclWrapperElement) return

  const positionChart = context.chart.canvas.getBoundingClientRect()
  const positionWrapper = hclWrapperElement.getBoundingClientRect()
  const tooltipOutsideWindowFrame = (positionChart.bottom + tooltipElement.offsetHeight) > window.innerHeight

  if (tooltipOutsideWindowFrame) {
    tooltipElement.style.top = positionChart.top - positionWrapper.top - tooltipElement.offsetHeight + 'px'
  } else {
    tooltipElement.style.top = positionChart.bottom - positionWrapper.top + 'px';
  }

  tooltipElement.style.left = positionChart.left - positionWrapper.left + 'px';
  tooltipElement.style.opacity = '1'
  tooltipElement.style.font = tooltip.options.bodyFont.string
  tooltipElement.style.padding = tooltip.options.padding + 'px'
}

const columnDonutOptions = (): any => {
  return {
    animation: false,
    interaction: {
      intersect: true,
      mode: 'index',
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false,
        position: 'nearest',
        external: columnDonutTooltipHandler
      }
    },
    onClick: (evt, elements, chart) => {
      if (elements.length === 0) return

      const index = elements[0].index
      const label = chart?.data?.labels[index]

      if (!label) return

      columnDonutSectionClicked.value = label
    }
  }
}

const columnDonutSize = (values: any) => {
  return values?.meta?.size ?? '60'
}

/*
 * Tags Handling
 */
const columnTagsBackgroundColor = (color) => {
  return `background-color: ${color}`
}
</script>

<style lang="scss">
.donut-canvas-wrapper {
  display: inline-block;
}

.donut-tooltip {
  background-color: white;
  border-radius: 0.25rem;
  border: 1px solid #343a40;
  color: #343a40;
  opacity: 1;
  pointer-events: none;
  position: absolute;
  z-index: 9999;

  table {
    margin: 0;

    tbody {
      tr {
        td {
          border: none;
          white-space: nowrap;

          span {
            display: inline-block;
            height: 0.75rem;
            width: 0.75rem;
            border: none;
            margin-right: 0.625rem;
          }
        }

      }

      .current {
        background-color: #ededed;
      }
    }
  }
}

.column-image {
  .image {
    height: v-bind('columnImageDimensions.height');
    width: v-bind('columnImageDimensions.width');
  }
}

.column-image-full-height {
  .image {
    height: v-bind('columnImageDimensions.height');
    width: v-bind('columnImageDimensions.width');
  }
}

.wrapper {
  .column-html {
    width: 100%;
  }

  .image-wrapper {
    .image-mode-contain {
      object-fit: contain;
    }

    .image-mode-cover {
      object-fit: cover;
    }

    .image-mode-scale-down {
      object-fit: scale-down;
    }
  }
}
</style>
